package com.example.crashbit

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

object AppIcons {
    val AcUnit: ImageVector by lazy {
        ImageVector.Builder(
            name = "AcUnit",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(fill = SolidColor(Color.White)) {
                moveTo(22f, 11f); lineTo(19.17f, 11f); lineTo(21.13f, 8.16f); lineTo(19.72f, 6.75f); lineTo(17f, 9.46f); lineTo(17f, 6f); lineTo(15f, 6f); lineTo(15f, 10.17f); lineTo(13f, 12f); lineTo(13f, 6f); lineTo(11f, 6f); lineTo(11f, 12f); lineTo(9f, 10.17f); lineTo(9f, 6f); lineTo(7f, 6f); lineTo(7f, 9.46f); lineTo(4.28f, 6.75f); lineTo(2.87f, 8.16f); lineTo(4.83f, 11f); lineTo(2f, 11f); lineTo(2f, 13f); lineTo(4.83f, 13f); lineTo(2.87f, 15.84f); lineTo(4.28f, 17.25f); lineTo(7f, 14.54f); lineTo(7f, 18f); lineTo(9f, 18f); lineTo(9f, 13.83f); lineTo(11f, 12f); lineTo(11f, 18f); lineTo(13f, 18f); lineTo(13f, 12f); lineTo(15f, 13.83f); lineTo(15f, 18f); lineTo(17f, 18f); lineTo(17f, 14.54f); lineTo(19.72f, 17.25f); lineTo(21.13f, 15.84f); lineTo(19.17f, 13f); lineTo(22f, 13f); close()
            }
        }.build()
    }

    val BarChart: ImageVector by lazy {
        ImageVector.Builder(
            name = "BarChart",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(fill = SolidColor(Color.White)) {
                moveTo(5f, 9.2f); lineTo(8f, 9.2f); lineTo(8f, 19f); lineTo(5f, 19f); close()
                moveTo(10.6f, 5f); lineTo(13.6f, 5f); lineTo(13.6f, 19f); lineTo(10.6f, 19f); close()
                moveTo(16.2f, 13f); lineTo(19.2f, 13f); lineTo(19.2f, 19f); lineTo(16.2f, 19f); close()
            }
        }.build()
    }

    val CameraAlt: ImageVector by lazy {
        ImageVector.Builder(
            name = "CameraAlt",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(fill = SolidColor(Color.White)) {
                moveTo(9f, 2f); lineTo(7.17f, 4f); lineTo(4f, 4f); curveTo(2.9f, 4f, 2f, 4.9f, 2f, 6f); lineTo(2f, 18f); curveTo(2f, 19.1f, 2.9f, 20f, 4f, 20f); lineTo(20f, 20f); curveTo(21.1f, 20f, 22f, 19.1f, 22f, 18f); lineTo(22f, 6f); curveTo(22f, 4.9f, 21.1f, 4f, 20f, 4f); lineTo(16.83f, 4f); lineTo(15f, 2f); lineTo(9f, 2f); close()
                moveTo(12f, 17f); curveTo(9.24f, 17f, 7f, 14.76f, 7f, 12f); curveTo(7f, 9.24f, 9.24f, 7f, 12f, 7f); curveTo(14.76f, 7f, 17f, 9.24f, 17f, 12f); curveTo(17f, 14.76f, 14.76f, 17f, 12f, 17f); close()
                moveTo(12f, 9f); curveTo(10.34f, 9f, 9f, 10.34f, 9f, 12f); curveTo(9f, 13.66f, 10.34f, 15f, 12f, 15f); curveTo(13.66f, 15f, 15f, 13.66f, 15f, 12f); curveTo(15f, 10.34f, 13.66f, 9f, 12f, 9f); close()
            }
        }.build()
    }

    val Eco: ImageVector by lazy {
        ImageVector.Builder(
            name = "Eco",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(fill = SolidColor(Color.White)) {
                moveTo(16.05f, 3f); curveTo(16.05f, 3f, 16f, 3f, 16f, 3f); curveTo(11.58f, 3f, 8f, 6.58f, 8f, 11f); curveTo(8f, 12.08f, 8.22f, 13.11f, 8.61f, 14.05f); lineTo(3.41f, 19.24f); lineTo(4.83f, 20.66f); lineTo(10.02f, 15.47f); curveTo(10.96f, 15.86f, 11.99f, 16.08f, 13.07f, 16.08f); curveTo(17.49f, 16.08f, 21.07f, 12.5f, 21.07f, 8.08f); curveTo(21.07f, 5.27f, 18.86f, 3.0f, 16.05f, 3f); close()
            }
        }.build()
    }

    val History: ImageVector by lazy {
        ImageVector.Builder(
            name = "History",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(fill = SolidColor(Color.White)) {
                moveTo(13f, 3f); curveTo(8.03f, 3f, 4f, 7.03f, 4f, 12f); lineTo(1f, 12f); lineTo(4.89f, 15.89f); lineTo(4.96f, 16.03f); lineTo(9f, 12f); lineTo(6f, 12f); curveTo(6f, 8.13f, 9.13f, 5f, 13f, 5f); curveTo(16.87f, 5f, 20f, 8.13f, 20f, 12f); curveTo(20f, 15.87f, 16.87f, 19f, 13f, 19f); curveTo(11.07f, 19f, 9.32f, 18.21f, 8.06f, 16.94f); lineTo(6.64f, 18.36f); curveTo(8.27f, 20.0f, 10.51f, 21f, 13f, 21f); curveTo(17.97f, 21f, 22f, 16.97f, 22f, 12f); curveTo(22f, 7.03f, 17.97f, 3f, 13f, 3f); close()
                moveTo(12f, 8f); lineTo(12f, 13f); lineTo(16.25f, 15.55f); lineTo(17f, 14.33f); lineTo(13.5f, 12.25f); lineTo(13.5f, 8f); close()
            }
        }.build()
    }

    val ExpandLess: ImageVector by lazy {
        ImageVector.Builder(
            name = "ExpandLess",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(fill = SolidColor(Color.White)) {
                moveTo(12f, 8f); lineTo(6f, 14f); lineTo(7.41f, 15.41f); lineTo(12f, 10.83f); lineTo(16.59f, 15.41f); lineTo(18f, 14f); close()
            }
        }.build()
    }

    val ExpandMore: ImageVector by lazy {
        ImageVector.Builder(
            name = "ExpandMore",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(fill = SolidColor(Color.White)) {
                moveTo(16.59f, 8.59f); lineTo(12f, 13.17f); lineTo(7.41f, 8.59f); lineTo(6f, 10f); lineTo(12f, 16f); lineTo(18f, 10f); close()
            }
        }.build()
    }

    val Public: ImageVector by lazy {
        ImageVector.Builder(
            name = "Public",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(fill = SolidColor(Color.White)) {
                moveTo(12f, 2f); curveTo(6.48f, 2f, 2f, 6.48f, 2f, 12f); curveTo(2f, 17.52f, 6.48f, 22f, 12f, 22f); curveTo(17.52f, 22f, 22f, 17.52f, 22f, 12f); curveTo(22f, 6.48f, 17.52f, 2f, 12f, 2f); close()
                moveTo(11f, 19.93f); curveTo(7.05f, 19.44f, 4f, 16.08f, 4f, 12f); curveTo(4f, 11.38f, 4.08f, 10.79f, 4.21f, 10.21f); lineTo(9f, 15f); lineTo(9f, 16f); curveTo(9f, 17.1f, 9.9f, 18f, 11f, 18f); close()
                moveTo(17.9f, 17.39f); curveTo(17.64f, 16.58f, 16.9f, 16f, 16f, 16f); lineTo(15f, 16f); lineTo(15f, 13f); curveTo(15f, 12.45f, 14.55f, 12f, 14f, 12f); lineTo(8f, 12f); lineTo(8f, 10f); lineTo(10f, 10f); curveTo(10.55f, 10f, 11f, 9.55f, 11f, 9f); lineTo(11f, 7f); lineTo(13f, 7f); curveTo(14.1f, 7f, 15f, 6.1f, 15f, 5f); lineTo(15f, 4.59f); curveTo(17.93f, 5.77f, 20f, 8.65f, 20f, 12f); curveTo(20f, 14.08f, 19.2f, 15.97f, 17.9f, 17.39f); close()
            }
        }.build()
    }

    val Delete: ImageVector by lazy {
        ImageVector.Builder(
            name = "Delete",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(fill = SolidColor(Color.White)) {
                moveTo(6f, 19f); curveTo(6f, 20.1f, 6.9f, 21f, 8f, 21f); lineTo(16f, 21f); curveTo(17.1f, 21f, 18f, 20.1f, 18f, 19f); lineTo(18f, 7f); lineTo(6f, 7f); lineTo(6f, 19f); close()
                moveTo(19f, 4f); lineTo(15.5f, 4f); lineTo(14.5f, 3f); lineTo(9.5f, 3f); lineTo(8.5f, 4f); lineTo(5f, 4f); lineTo(5f, 6f); lineTo(19f, 6f); lineTo(19f, 4f); close()
            }
        }.build()
    }

    val Star: ImageVector by lazy {
        ImageVector.Builder(
            name = "Star",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(fill = SolidColor(Color.White)) {
                moveTo(12f, 17.27f); lineTo(18.18f, 21f); lineTo(16.54f, 13.97f); lineTo(22f, 9.24f); lineTo(14.81f, 8.63f); lineTo(12f, 2f); lineTo(9.19f, 8.63f); lineTo(2f, 9.24f); lineTo(7.46f, 13.97f); lineTo(5.82f, 21f); close()
            }
        }.build()
    }

    val ArrowBack: ImageVector by lazy {
        ImageVector.Builder(
            name = "ArrowBack",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(fill = SolidColor(Color.White)) {
                moveTo(20f, 11f); lineTo(7.83f, 11f); lineTo(13.42f, 5.41f); lineTo(12f, 4f); lineTo(4f, 12f); lineTo(12f, 20f); lineTo(13.41f, 18.59f); lineTo(7.83f, 13f); lineTo(20f, 13f); close()
            }
        }.build()
    }
}
